import { useQuery } from '@tanstack/react-query';
import { fetchWholesaleRecentTransac, type WholesaleOrder } from '../services/wholesaleRecentTransacService';


export const useWholesaleRecentTransac = (limit = 60) => {
  return useQuery<WholesaleOrder[], Error>({
    queryKey: ['wholesale-recentTransactions', limit],
    queryFn: () => fetchWholesaleRecentTransac(limit),
    staleTime: 1000 * 60 * 5,
  });
};